<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef">
      <template slot="searchBar">
        <el-form-item label="厂商名称">
          <el-input v-model.trim="tableData.search.name" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button v-if="checkApi('addCompany')" size="small" type="primary" @click="add">添加厂商</el-button>
      </template>
      <template v-if="hasApi(['reviseCompany','deleteCompany'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="120">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('reviseCompany')" type="text" @click="revise(row)">修改</el-button>
            <el-button v-if="checkApi('deleteCompany')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <company-operate v-if="companyOperate.visible" :dialog-data="companyOperate" @table-reload="getTableList"/>
  </div>
</template>

<script>
  import CompanyOperate from "./dialog/CompanyOperate"
  export default {
    name: "companyManage",
    components: {CompanyOperate},
    data() {
      return {
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "ID", property: "id"},
            {label: "类型名称", property: "name"},
            {label: "添加时间", property: "create_at"},
            {label: "创建人", property: "admin.name"},
          ],
          api: "getCompanyList",
          search: {
            name: "",
          },
        },
        companyOperate: {visible: false, width: 400, title: "", row: null},
      }
    },
    methods: {
      add() {
        this.companyOperate.visible = true;
        this.companyOperate.title = "添加厂商";
        this.companyOperate.row = null;
      },
      revise(row) {
        this.companyOperate.visible = true;
        this.companyOperate.title = "修改厂商";
        this.companyOperate.row = row;
      },
      remove(row) {
        this.openConfirm("删除该厂商", async ()=> {
          let nv = {company_id: row.id};
          let res = await this.$Http.deleteCompany(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
